import React, { Component } from 'react'
import { Redirect, withRouter } from 'react-router-dom'
import { getJwtAuthenticationToken } from '../../../services/vu'
import Loading from '../../pages/Loading'
import { getProperty } from '../../../helpers/properties'
import {
  getCourseId,
  setCourseIdViaQueryParameter
} from '../../../helpers/course'
import Error from '../../pages/Error'
import { getConfiguration } from '../../../helpers/configuration'
import qs from 'qs'
import {
  setOfferApplicationId,
  setOfferApplicationLineId
} from '../../../helpers/offer'

class Login extends Component {
  constructor(props) {
    super(props)

    this.state = {
      authenticated: false,
      failed: false,
      jwToken: '',
      path: ''
    }
  }

  componentDidMount() {
    setCourseIdViaQueryParameter(this.props.location.search)
    setOfferApplicationLineId(this.props.location.search)
    setOfferApplicationId(this.props.location.search)

    getJwtAuthenticationToken().then(tokenGenerated => {
      let path = getConfiguration('publicPath')
      const queryParams = qs.parse(this.props.location.search, {
        ignoreQueryPrefix: true
      })
      const pathParameter = Object.keys(queryParams).find(
        queryParam => queryParam.toLocaleLowerCase() === 'path'
      )
      if (pathParameter && queryParams.hasOwnProperty(pathParameter)) {
        let pathValue = queryParams[pathParameter]
        if (pathValue.startsWith('/')) {
          if (path === '/') {
            path = ''
          } else if (path.endsWith('/')) {
            pathValue = pathValue.substring(1)
          }
        } else if (!path.endsWith('/')) {
          pathValue = '/' + pathValue
        }
        path += pathValue
      }

      this.setState({
        authenticated: tokenGenerated[0],
        failed: tokenGenerated[1],
        path: path
      })
    })
  }

  render() {
    if (this.state.authenticated) {
      return (
        <Redirect
          to={{
            pathname: this.state.path,
            state: { from: this.props.location }
          }}
        />
      )
    } else if (this.state.failed) {
      return (
        <Error
          className="page__error--maintenance"
          title="Authentication failed"
          longDescription="Authentication has failed."
          hideContactInfo={false}
        />
      )
    }
    return <Loading />
  }
}

export default withRouter(Login)
